/**
 * Copyright © Veeam Software Group GmbH.
 */

import { PulseLicenseInstallationStatus as PulseLicenseInstallationStatusModel } from '@veeam-vspc/models/web-controllers';

export type PulseLicenseInstallationStatus = PulseLicenseInstallationStatusModel;
export const PulseLicenseInstallationStatus = PulseLicenseInstallationStatusModel;
